import axios from 'axios'

export default {

  /**
   * Get the job
   * @returns {AxiosPromise<any>}
   */
  getunsubscribe (params) {
    return axios.get(`subscribe-check`, {params})
  },
    /**
   * Unsubscribe
   * @returns {AxiosPromise<any>}
   */
    subscribeReceive (data) {
      return axios.post('/subscribe/sub-post', data)
    }

}



// WEBPACK FOOTER //
// ./src/api/unsubscribe.js